import React from "react";
import { Sparkles } from "lucide-react";
import styles from "./AskAiButton.module.css";

const AskAiButton = ({ onClick, isActive }) => {
  return (
    <button
      type="button"
      className={`${styles.button} ${isActive ? styles.active : ""}`}
      onClick={onClick}
    >
      <Sparkles size={16} />
      Ask Question to Ai
    </button>
  );
};

export default AskAiButton;
